import type { ChatHeaderComponent } from "./_types";

import { memo, forwardRef } from "react";
import { useTranslation } from "react-i18next";

import { Button, Tooltip } from "antd";
import { clsx } from "clsx";

import { default as classes } from "./_.module.scss";
import { useChatHeader } from "./_hooks";

import { AntdIcon } from "~/libs/antd/icon";

/**
 * ChatHeader Component View
 */
export default memo(
  forwardRef((props, ref) => {
    /** useHooks */
    const {
      divRef,
      logoUrl,
      chatbotName,
      hasMenu,
      handleOpenSidebar,
      handleAddConversation,
      handleClose,
    } = useChatHeader({ ref, ...props });

    const { t } = useTranslation("common");
    /** render */
    return (
      <div ref={divRef} className={clsx(props.className, classes.chatHeader)}>
        <div className={classes.leftSection}>
          {hasMenu && (
            <Tooltip title={t("chat.header.menu")}>
              <Button
                type="text"
                size="small"
                className={classes.menuBtn}
                icon={<AntdIcon name="MenuOutlined" />}
                onClick={handleOpenSidebar}
              />
            </Tooltip>
          )}

          {logoUrl && <img src={logoUrl} alt="logo" className={classes.logo} />}

          {chatbotName && (
            <span className={classes.botName}>{chatbotName}</span>
          )}
        </div>

        <div className={classes.rightSection}>
          <Tooltip title={t("chat.header.addConversation")}>
            <Button
              type="text"
              size="small"
              className={classes.actionBtn}
              icon={<AntdIcon name="FormOutlined" />}
              onClick={handleAddConversation}
            />
          </Tooltip>

          <Tooltip title={t("chat.header.close")}>
            <Button
              type="text"
              size="small"
              className={classes.actionBtn}
              icon={<AntdIcon name="CloseOutlined" />}
              onClick={handleClose}
            />
          </Tooltip>
        </div>
      </div>
    );
  })
) as ChatHeaderComponent;
